import 'jquery';
import 'jquery-mask-plugin';
import './new/notify';
import './new/datepicker.min';
import './new/jquery.fancybox';

function segmentName(segment) {
  let res;

  let { from } = segment;
  let { to } = segment;

  let from_unit; let
    to_unit;

  const show_from = false;

  if (from < 60) {
    from_unit = ngettext('minute', 'minutes', from);
  } else {
    // if (from > 180) {
    //     show_from = true;
    // } не нужно в новом дизайне
    from = Math.floor(from / 60);
    from_unit = ngettext('hour', 'hours', from);
  }

  if (to < 60) {
    to_unit = ngettext('minute', 'minutes', to);
  } else if (to < (60 * 24)) {
    to = Math.floor(to / 60);
    to_unit = ngettext('hour', 'hours', to);
  } else {
    to = Math.floor(to / (60 * 24));
    to_unit = ngettext('day', 'days', to);
  }

  if (from && to && show_from) {
    res = `${gettext('from')} ${from} ${gettext('to')} ${to} ${to_unit}`;
  } else if ((!from && to) || !show_from) {
    res = `${gettext('up to')} ${to} ${to_unit}`;
  } else if (!to && from) {
    res = `${gettext('more than')} ${from} ${from_unit}`;
  }
  return res;
}


function isEmail(email) {
  const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

$(document).ready(() => {
  const lang = getCookie('language_v4');
  const csrftoken = getCookie('csrftoken_v4');

  /* маска ввода:
     a — трактуется как буквенный символ из диапазона (A-Z,a-z)
     9 — трактуется как числовой символ (0-9)
     * — трактуется как алфавитно цифровой символ (A-Z,a-z,0-9)
     */

  // селектор тарифов
  const rateSelector = $('#u_rate_selector');
  // расширенный доступ
  const priceCheck = $('#price-popup1__check');
  // чекбокс соглашения
  const selectPayment = $('#id3');

  /* Адский костыль, который стирает надпись "(+None ₽)" в расширенном доступе к прокату @todo - убрать */
  // var badElement = $('span.check-label__price');

  // function clearBadText() {
  //     if (badElement && badElement.length) {
  //         badElement.each(function(){
  //             if ($(this).text() === '(+None ₽)' || $(this).text() === '+None ₽') {
  //                 $(this).text('');
  //             }
  //         });
  //     }
  // }

  // clearBadText();
  // $('.checkbox, #u_rate_selector').change(function() {
  //     clearBadText();
  // });

  // при загрузке страницы снимаем чекбокс
  priceCheck.prop('checked', false);
  selectPayment.prop('checked', false);

  // при переключении селектора так же снимаем чекбокс
  rateSelector.change(() => {
    priceCheck.prop('checked', false);
    selectPayment.prop('checked', false);
    sumbitPayment.prop('disabled', !selectPayment.prop('checked'));
  });


  var maskChanged = false;
  // console.log('ready');
  jQuery(($) => {
      const troikaInputHandler = (e) => {
        if (e && e.target && e.target.value) {
        const troikaVal = e.target.value;
        const troikaBtn = $('#troika-btn-link');
   if (troikaVal && troikaVal.length && troikaVal.length === 12) {
    troikaBtn.prop('disabled', false);
   } else troikaBtn.prop('disabled', true);
  }
 }

  const troikaField = $('#id_troika_card_number');
  if (troikaField) {
  troikaField.on('input', troikaInputHandler);
  }

  $('#id_troika_card_number')
  .mask('9999 999 999', { placeholder: 'XXXX XXX XXX', completed() {} });

    // $("#restore_pin_form [name=phone_number]").mask("9999999999999",{completed:function(){
    // $("#restore_pin_btn").prop("disabled", false);
    // }});

    // Форма регистрации - форматирование имени и фамилии
    const RegLettersExpression = /^[a-zA-Za-яёА-ЯЁ\-\s]*$/;
    $('#register_form [name=first_name],'
            + '#register_form [name=last_name],'
            + '#register_index_form [name=first_name],'
            + '#register_index_form [name=last_name]')
      .change(function () {
        if ($(this).val().search(RegLettersExpression) === -1) {
          $(this).notify(gettext('Letters, spaces and dashes only'), 'error');
          $(this).val('');
        }
      });

      const promoInputHandler = (e) => {
        if (e && e.target && e.target.value) {
        const val = e.target.value;
        if (!val || val.length < 6 || val.length > 9 || val.length === 7 || val.length === 8) {
          $('#submit-promocode').prop('disabled', true);
        } else {
          $('#submit-promocode').prop('disabled', false);
        }
   }
}

  const promoField = $('#input-promocode');
  if (promoField) {
    promoField.on('input', promoInputHandler);
  }

    const datepickerParams = {
      format: 'yyyy.mm.dd',
      weekStart: 1,
      startView: 2,
      autoHide: true,
      startDate: '1900.01.01',
      endDate: new Date(new Date().setFullYear(new Date().getFullYear() - 16)),
    };

    if (lang === 'ru') {
      datepickerParams.language = 'ru-RU';
    } else {
      datepickerParams.language = 'en-US';
    }

    $('.datepicker').datepicker(datepickerParams);
  });
  //

  // форма деталей для страховки
  /*
    * При покупке расширенного доступа возможно указать любой год рождения, например 2020.
     Сделать аналогично приложению: верхняя граница - не младше 16 лет, нижняя граница - 1900

     + поменять формат даты: сейчас гггг.мм.дд, надо дд.мм.гггг.
    * */
  const insuranceForm = $('#insurance-form');
  const insuranceFormDate = $('#id_birthday');
  const insuranceFormFirstName = $('#id_first_name');
  const insuranceFormLastName = $('#id_last_name');
  const btnSubmit = $('#btn-submit');

  function isValidDate(dateString) {
    // First check for the pattern
    const regex_date = /^\d{4}\.\d{2}\.\d{2}$/;

    if (!regex_date.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split('.');
    const day = parseInt(parts[2], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[0], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
      return false;
    }

    if (year < 1900) {
      return false;
    }

    if (new Date(year, month - 1, day, 0, 0, 0, 0) > new Date(new Date().setFullYear(new Date().getFullYear() - 16, new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0))) {
      return false;
    }

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }

  insuranceForm.submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    btnSubmit.prop('disabled', true);

    if (!isValidDate(insuranceFormDate.val())) {
      // не дата, возвращаем, кнопку дизаблим
      insuranceFormDate.notify('Неверный формат даты! ', 'error');
      insuranceFormDate.val('');
      btnSubmit.prop('disabled', false);
      return;
    }
    if (!insuranceFormFirstName.val().length) {
      insuranceFormFirstName.notify('Вы не ввели имя!', 'error');
      btnSubmit.prop('disabled', false);
      return;
    }
    if (!insuranceFormLastName.val().length) {
      insuranceFormLastName.notify('Вы не ввели фамилию!', 'error');
      btnSubmit.prop('disabled', false);
      return;
    }

    let profileUrl = '/api/account/modify_profile/';

    if (lang !== 'ru') {
      profileUrl = `/${lang}${profileUrl}`;
    }

    $.ajax({
      type: 'POST',
      url: profileUrl,
      processData: false, // Important!
      contentType: false,
      headers: { 'X-CSRFToken': csrftoken },
      cache: false,
      data,
      success(resp) {
        if (resp.status === 'ok') {
          $('#next_step_form').submit();
        } else {
          btnSubmit.prop('disabled', false);
          alert(resp.error.message || 'Произошла ошибка. Проверьте введенные данные!');
        }
        // location.reload();
        // @todo локализация алерта! А лучше - кастомный алерт в дизайне
        // @todo валидация формы!
        return true;
      },
      error(err) {
        console.log('err', err);
        btnSubmit.prop('disabled', false);
        alert('Произошла ошибка. Проверьте введенные данные!');
      },
    });
  });


  // форма профиля пользователя
  $('#profile-form').submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const btnSubmit = $('#btn-submit');
    btnSubmit.prop('disabled', true);
    // console.log(data);
    const insuranceFormDateTime = $('#id_birthday');
    const rawDate = insuranceFormDateTime.val();

    if (!isValidDate(rawDate)) {
      // не дата, возвращаем, кнопку дизаблим
      insuranceFormDateTime.notify('Неверный формат даты!', 'error');
      insuranceFormDateTime.val('');
      btnSubmit.prop('disabled', false);
      return;
    }

    let profileUrl = '/api/account/modify_profile/';

    if (lang !== 'ru') {
      profileUrl = `/${lang}${profileUrl}`;
    }

    $.ajax({
      type: 'POST',
      url: profileUrl,
      enctype: 'multipart/form-data',
      processData: false, // Important!
      headers: { 'X-CSRFToken': csrftoken },
      contentType: false,
      cache: false,
      data,
      success(resp) {
        if (resp.status == 'ok') {
          btnSubmit.prop('disabled', false);
          alert(resp.status);
        } else {
          btnSubmit.prop('disabled', false);
          alert(resp.error.message);
        }
        // location.reload();
        // @todo локализация алерта! А лучше - кастомный алерт в дизайне
        // @todo валидация формы!

        return true;
      },
    });
  });

  // форма привязки-отвязки карты "тройка"
  $('#troika-form').submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const btnSubmit = $('#troika-btn');
    btnSubmit.prop('disabled', true);

    let apiPath = $('#link-action').val() == 'link' ? '/api/account/bind_troika/' : '/api/account/unbind_troika/';

    if (lang !== 'ru') {
      apiPath = `/${lang}${apiPath}`;
    }

    $.ajax({
      type: 'POST',
      url: apiPath,
      enctype: 'multipart/form-data',
      processData: false, // Important!
      contentType: false,
      headers: { 'X-CSRFToken': csrftoken },
      cache: false,
      data,
      success(resp) {
        if (resp.status == 'ok') {
          btnSubmit.prop('disabled', false);
          if ($('#link-action').val() == 'link') {
            $.notify(gettext('troika_linked'), 'success');
            $('#link-action').val('unlink');
            $('#troika-btn-link').val(gettext('Unlink Troika'));
          } else {
            $.notify(gettext('troika_unlinked'), 'success');
            $('#link-action').val('link');
            $('#troika-btn-link').val(gettext('Add Troika'));
            $('#id_troika_card_number').val('');
            $('#troika-btn-link').prop('disabled', true);
          }
        } else {
          btnSubmit.prop('disabled', false);
          $.notify(resp.error.message, 'error');
        }
        // location.reload();
        // @todo локализация алерта! А лучше - кастомный алерт в дизайне
        return true;
      },
    });
  });

  // Форма ввода промокода
  // promocode-form
  $('#promocode-form').submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const btnSubmit = $('#submit-promocode');
    btnSubmit.prop('disabled', true);
    let apiPath = btnSubmit.length ? '/api/account/promo_code/' : '';

    if (lang !== 'ru') {
      apiPath = `/${lang}${apiPath}`;
    }

    $.ajax({
      type: 'POST',
      url: apiPath,
      enctype: 'multipart/form-data',
      processData: false, // Important!
      contentType: false,
      headers: { 'X-CSRFToken': csrftoken },
      cache: false,
      data,
      success(resp) {
        if (resp.status === 'ok') {
          btnSubmit.prop('disabled', false);
          $.notify(resp.status, 'success');

          // Сделано для того, чтобы компонент AccountRates пересчитал данные о доступных тарифах из бэкенда
          $('#user_balance').val(resp.balance);
          $('#user_balance').trigger('click');
          $('#balance_value').html(`${resp.balance}<span class="cur">₽</span>`);
        } else {
          btnSubmit.prop('disabled', false);
          if (resp && resp.error && resp.error.message && resp.error.message.length > 0) {
          $.notify(resp.error.message, 'error');
          } else $.notify('Указан неверный Бонус-код', 'error'); 
        }
        // @todo локализация алерта! А лучше - кастомный алерт в дизайне
        return true;
      },
    });
  });
  $('#login_form').submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    let apiPath = '/api/login/';
    if (lang === 'en') {
      apiPath = `/en${apiPath}`;
    }

    $.ajax({
      type: 'POST',
      url: apiPath,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      cache: false,
      data,
      success(resp) {
        // console.log(resp);
        if (resp.status === 'ok') {
          location.href = resp.redirect_to;
        } else {
          $.notify(gettext('Invalid login/password'), 'error', { position: 'bottom center' });
        }

        return true;
      },
      error(resp) {

      },
    });
  });
  // Форма регистрации
  $('#register_form').submit((event) => {
    // Попап
    maskChanged = false;
    event.preventDefault();
    let formError = 0;
    const registerFormFirstName = $('#register_form [name=first_name]');
    const registerFormLastName = $('#register_form [name=last_name]');
    const registerFormPhone = $('#register_form [name=phone_number]');
    const registerFormEmail = $('#register_form [name=email]');
    const registerFormAgree = $('#id1');

    if (!registerFormFirstName.val().length) {
      registerFormFirstName.notify(gettext('Name field is incomplete'), 'error');
      formError = 1;
    }
    if (!registerFormLastName.val().length) {
      registerFormLastName.notify(gettext('Surname field is incomplete'), 'error');
      formError = 1;
    }
    if (!registerFormPhone.val().length) {
      registerFormPhone.notify(gettext('Phone field is incomplete'), 'error');
      formError = 1;
    }
    if (!registerFormEmail.val().length) {
      registerFormEmail.notify(gettext('E-mail field is incomplete'), 'error');
      formError = 1;
    } else if (!isEmail(registerFormEmail.val())) {
      registerFormEmail.notify(gettext('E-mail format is incorrect'), 'error', { autoHide: false });
      formError = 1;
    }
    if (formError) {
      return false;
    }

    const data = {
      first_name: registerFormFirstName.val(),
      last_name: registerFormLastName.val(),
      email: registerFormEmail.val(),
      agree_terms: 'true',
      phone_number: registerFormPhone.val().replace(/[^0-9]/g, ''),
    };

    let apiPath = '/api/registration/';

    if (lang !== 'ru') {
      apiPath = `/${lang}${apiPath}`;
    }

    $.ajax({
      type: 'POST',
      url: apiPath,
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers: { 'X-CSRFToken': csrftoken },
      data: JSON.stringify(data),
      success(resp) {
        // console.log(resp);
        if (resp.status == 'ok') {
          // console.log('thanks!');
          $.notify(gettext('registration_ok'), 'success');
          registerFormFirstName.val('');
          registerFormLastName.val('');
          registerFormEmail.val('');
          registerFormPhone.val('');
          registerFormAgree.prop('checked', false);
          $('#register-button-popup').prop('disabled', 'true');
          $.fancybox.open('#popup2');
        } else {
          // console.log('error');phone_exists
          if (resp.error.message === 'phone_exists') {
            $.notify(gettext('phone_exists'), 'error');
          } else if (resp.error.message === 'email_exists') {
            $.notify(gettext('email_exists'), 'error');
          } else {
            $.notify(resp.error.message, 'error');
          }
        }

        return true;
      },
      error(resp) {

      },
    });
  });
  $('#id1').change(() => {
    if ($('#id1').prop('checked')) {
      $('#register-button-popup').removeAttr('disabled');
    } else {
      $('#register-button-popup').prop('disabled', 'true');
    }
  });

  // $("#register_index_form").submit(function (event) {
  $('#register_index_form').submit((event) => {
    // Форма на главной
    maskChanged = false;
    event.preventDefault();
    let formError = 0;
    const registerFormFirstName = $('#register_index_form [name=first_name]');
    const registerFormLastName = $('#register_index_form [name=last_name]');
    const registerFormPhone = $('#register_index_form [name=phone_number]');
    const registerFormEmail = $('#register_index_form [name=email]');
    const registerFormAgree = $('#id');

    if (!registerFormFirstName.val().length) {
      registerFormFirstName.notify(gettext('Name field is incomplete'), 'error');
      formError = 1;
    }
    if (!registerFormLastName.val().length) {
      registerFormLastName.notify(gettext('Surname field is incomplete'), 'error');
      formError = 1;
    }
    if (!registerFormPhone.val().length) {
      registerFormPhone.notify(gettext('Phone field is incomplete'), 'error');
      formError = 1;
    }
    if (!registerFormEmail.val().length) {
      registerFormEmail.notify(gettext('E-mail field is incomplete'), 'error');
      formError = 1;
    } else if (!isEmail(registerFormEmail.val())) {
      registerFormEmail.notify(gettext('E-mail format is incorrect'), 'error', { autoHide: false });
      formError = 1;
    }
    if (formError) {
      return false;
    }

    const data = {
      first_name: registerFormFirstName.val(),
      last_name: registerFormLastName.val(),
      email: registerFormEmail.val(),
      agree_terms: 'true',
      phone_number: registerFormPhone.val().replace(/[^0-9]/g, ''),
    };

    let apiPath = '/api/registration/';

    if (lang !== 'ru') {
      apiPath = `/${lang}${apiPath}`;
    }

    $.ajax({
      type: 'POST',
      url: apiPath,
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers: { 'X-CSRFToken': csrftoken },
      data: JSON.stringify(data),
      success(resp) {
        // console.log(resp);
        if (resp.status === 'ok') {
          // console.log('thanks!');
          $.notify(gettext('registration_ok'), 'success');
          registerFormFirstName.val('');
          registerFormLastName.val('');
          registerFormEmail.val('');
          registerFormPhone.val('');
          registerFormAgree.prop('checked', false);
          $('#register-button').prop('disabled', 'true');

          $.fancybox.open('#popup2');
        } else {
          // console.log('error');
          if (resp.error.message === 'phone_exists') {
            $.notify(gettext('phone_exists'), 'error');
          } else if (resp.error.message === 'email_exists') {
            $.notify(gettext('email_exists'), 'error');
          } else {
            $.notify(resp.error.message, 'error');
          }
        }

        return true;
      },
      error(resp) {

      },
    });
  });

  const avatarDropElement = document.getElementById('avatarDrop');

  if (avatarDropElement !== null && avatarDropElement !== undefined) {

    var avatarDrop = new Dropzone('#avatarDrop', {
      url: '/api/account/modify_avatar/',
      paramName: 'avatar',
      autoProcessQueue: false,
      previewsContainer: '#drag-area',
      headers: { 'X-CSRFToken': csrftoken },
      previewTemplate: "<div class='dz-preview dz-file-preview'><img data-dz-thumbnail /></div> <div class='dz-progress'><span class='dz-upload' data-dz-uploadprogress></span></div>",
      init: function() {
        this.on('addedfile', function() {
          if (this.files[1] != null){
            this.removeFile(this.files[0]);
          }
        });
      }
    });

    $("#dnd-delete-image").on('click', function() {
      avatarDrop.removeAllFiles(true);
      $(".dz-message").show();
    });

    avatarDrop.on("addedfile", function(file) {
      $(".dz-message").hide();
      $("#dnd-upload-btn").on('click', function() {

        avatarDrop.processQueue();
      });
    });

    avatarDrop.on("success", function(fileInfo, serverEvent) {
      if(serverEvent.status == 'ok'){
        $.notify(gettext('Profile picture is successfully updated'), 'success');
        parent.$.fancybox.close();
        avatarDrop.removeAllFiles(true);
        $(".dz-message").show();
        $(document).trigger('avatarChange', serverEvent)

      }
    });

  }

  $('#id').change(() => {
    if ($('#id').prop('checked')) {
      $('#register-button').removeAttr('disabled');
    } else {
      $('#register-button').prop('disabled', 'true');
    }
  });
  $('#feedback_form').submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const submitBtn = $('.contacs-form__submit');
    const emailField = $('#feedback_form [name=email]');
    const titleField = $('#feedback_form [name=title]');
    const textField = $('#feedback_form [name=text]');

    let apiPath = '/api/feedback/';

    if (lang !== 'ru') {
      apiPath = `/${lang}${apiPath}`;
    }

    if (emailField.val() != null && !emailField.val().length) {
      emailField.notify(gettext('E-mail field is incomplete'), 'error');
      return false;
    } if (emailField.val() != null && !isEmail(emailField.val())) {
      emailField.notify(gettext('E-mail format is incorrect'), 'error', { autoHide: false });
      return false;
    }

    if (titleField.length > 0) {
      if (!titleField.val() || (titleField.val() && titleField.val().length === 0)) {
        titleField.notify('Не заполнено поле - тема сообщения!', 'error');
        return false;
      }
    }

    if (textField.length > 0) {
      if (!textField.val() || (textField.val() && textField.val().length === 0)) {
        textField.notify(gettext('Message field is incomplete'), 'error');
        return false;
      }
    }

    submitBtn.attr('disabled', 'disabled');

    $.ajax({
      type: 'POST',
      url: apiPath,
      enctype: 'multipart/form-data',
      headers: { 'X-CSRFToken': csrftoken },
      processData: false,
      contentType: false,
      cache: false,
      data,
      success(resp) {
        // console.log(resp);
        if (resp != null) {
          if (resp.status === 'error') {
            $.notify('Текст вопроса является обязательным!', 'error');
          }
        } else {
          $.notify(gettext('feedback_success'), 'success');
          emailField.val('');
          textField.val('');
          titleField.val('');
          submitBtn.attr('disabled', false);
        }

        return true;
      },
      error(resp) {

      },
    });
  });
  $('#restore_pin_form').submit((event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    let apiPath = '/api/restore_pin/';

    if (lang !== 'ru') {
      apiPath = `/${lang}${apiPath}`;
    }

    $.ajax({
      type: 'POST',
      url: apiPath,
      enctype: 'multipart/form-data',
      headers: { 'X-CSRFToken': csrftoken },
      processData: false,
      contentType: false,
      cache: false,
      data,
      success(resp) {
        if (resp.status == 'ok') {
          $.notify(gettext('restore_pin_ok'), 'success');
        } else {
          $.notify(resp.error.message, 'error');
        }

        return true;
      },
      error(resp) {

      },
    });
  });

  $('#debt_pay_link').click((e) => {
    e.preventDefault();

    const elem = $('#recurrent_card_popup');

    elem.addClass('popup-active');
    elem.css({ display: 'block' }); // .popup
    $.fancybox.open(elem);
  });

  $('#recurrent_card_popup').find('a.btn-red').click((e) => {
    e.preventDefault();
    const debt_form = $('#debt_form');
    debt_form.submit();
  });

  /*
     Логика:
     Если type "optional", то есть возможность поставить чекбокс, при этом логика как на макете
     Если type "mandatory", то чекбокс по умолчанию включен и его снять нельзя, тариф на этом аккаунте есть всегда.
     Если Insurance-атрибутов нет, то не отображаем блок с страховкой вообще.

     data-cost -- Стоимость тарифа до страховки
     data-insurance-cost -- Стоимость страховки
     data-after-insurance-cost -- Стоимость с страховкой (по сути сумма первого + второго)
     */

  // При покупке условия на галочку расширенного доступа срабатывают по дата аттрибутам в #captions-1 и в выбранной опции #u_rate_selector option:selected
  const captionSecondStep = $('#captions-1');
  var sumbitPayment = $('#submit3');
  const rateSelectedOption = $('#u_rate_selector option:selected');

  let dataCost = null;
  let dataInsuranceType = null;
  let dataInsuranceCost = null;
  let dataAfterInsuranceCost = null;
  let val = null;

  // Если это второй шаг
  if (captionSecondStep && captionSecondStep.length) {
    dataCost = captionSecondStep.attr('data-cost');
    dataInsuranceType = captionSecondStep.attr('data-insurance-type');
    dataInsuranceCost = captionSecondStep.attr('data-insurance-cost');
    dataAfterInsuranceCost = captionSecondStep.attr('data-after-insurance-cost');
  }
  // Если это треий шаг
  if (rateSelector && rateSelector.length) {
    dataCost = rateSelectedOption.attr('data-cost');
    dataInsuranceType = rateSelectedOption.attr('data-insurance-type');
    dataInsuranceCost = rateSelectedOption.attr('data-insurance-cost');
    dataAfterInsuranceCost = rateSelectedOption.attr('data-after-insurance-cost');
    val = rateSelectedOption.attr('value');
  }

  if (dataInsuranceType && dataInsuranceType == 'mandatory') {
    priceCheck.prop('checked', true);
    priceCheck.prop('disabled', true);

    // Костыль, если страховка обязательна, то чекбокс страховки задизаблен, поэтому
    // делаем скрытый input рядом
    priceCheck.next('label').after($('<input type="hidden" name="is_insured_real" value="1">'));
  } else {
    // А если страховка не обязательна, то убираем
    priceCheck.next('label').next('input[name="is_insured_real"]').remove();
  }
  /* if(!dataInsuranceType || !dataInsuranceCost){
        priceCheck.parent().parent().remove();
    } */
  sumbitPayment.prop('disabled', !selectPayment.prop('checked'));
  selectPayment.on('change', (event) => {
    sumbitPayment.prop('disabled', !event.target.checked);
  });
});

// dropdown, в том числе городов в шапке
try {
  const dropdown = document.querySelectorAll('.custom-select-wrapper');
  dropdown.forEach((dropdownElement) => {
    dropdownElement.addEventListener('click', () => {
      dropdownElement.querySelector('.custom-select').classList.toggle('open');
    });
  });
  const options = document.querySelectorAll('.custom-option');
  options.forEach((option) => {
    option.addEventListener('click', () => {
      if (!option.classList.contains('selected')) {
        option.parentNode.querySelector('.custom-option.selected').classList.remove('selected');
        option.classList.add('selected');
        // eslint-disable-next-line no-param-reassign
        option.closest('.custom-select').querySelector('.custom-select__trigger span').textContent = option.textContent;
        // redirect to domain if it is
        if (option.parentNode.id === 'city-select-options') {
          if (option.dataset.link) {
            window.location.href = option.dataset.link;
          }
        }
      }
    });
  });

  window.addEventListener('click', (e) => {
    const customSelect = document.querySelectorAll('.custom-select');
    customSelect.forEach((customSelectElement) => {
      if (!customSelectElement.contains(e.target)) {
        customSelectElement.classList.remove('open');
      }
    });
  });
} catch (e) {
  console.log('dropdown error', e);
}
